"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = StarIcon;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function StarIcon(_ref) {
  var size = _ref.size,
      variant = _ref.variant;
  var starUrl = 'https://s3-us-west-1.amazonaws.com/housecall-icons-production/icons/images/';

  if (variant === 'empty') {
    starUrl += 'star_empty.png';
  } else if (variant === 'full') {
    starUrl += 'star_full.png';
  } else if (variant == 'half') {
    starUrl += 'star_half.png';
  } else if (variant == 'oneQuarter') {
    starUrl += 'star_one_quarter.png';
  } else if (variant == 'threeQuarters') {
    starUrl += 'star_three_quarters.png';
  }

  return _react.default.createElement("img", {
    src: starUrl,
    alt: variant,
    style: size ? {
      height: size
    } : {
      height: 40
    }
  });
}